import { stripLangPrefix } from '@/seo/marketing-routes';

/**
 * The marketing landing family: `/home` and its sub pages, in every UI
 * language (`/es/home/about` counts). `/` is NOT here — `RootRedirect` in
 * App.tsx already sends a signed-in visitor to the dashboard on its own.
 */
const LANDING_PREFIXES = ['/home'];

/**
 * Where a sign-in or sign-up arrives (2026-09-15): the gate that decides
 * onboarding vs dashboard without ever showing the dashboard on the way —
 * `src/pages/onboarding.tsx`. `RootRedirect` and the landing-page dialog both
 * send here; `/dashboard` sends an un-onboarded visitor here too.
 */
export const ONBOARDING_PATH = '/onboarding';

/** Is this (possibly lang-prefixed) pathname a landing page? */
export function isLandingPath(pathname: string): boolean {
  const path = stripLangPrefix(pathname);
  return LANDING_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

/**
 * Where the auth dialog sends the user once they are signed in, or `null`
 * to leave them where they are.
 *
 * A landing page hands off to `/onboarding` — the onboarding-or-dashboard gate:
 * a signed-in user has nothing to do on the marketing site, and before this
 * the dialog simply closed and left them on `/home` with a "Get started"
 * button that now needed a second click. Anywhere else stays put — the deck
 * they were previewing, the redeem code, the invite — because that page IS
 * the thing they signed in for.
 */
export function postAuthPath(pathname: string): string | null {
  return isLandingPath(pathname) ? ONBOARDING_PATH : null;
}
